import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { cloneElement } from 'react';
import Box from '../Box';
import { getForegroundColor, useBoxSize } from '../system';
import StackView from '../StackView';
import Text from '../Text';
import { stopPropagationClick } from '../utils';

function Badge(_ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? {
    foreground: 'foreground',
    background: 'surfaceTertiary'
  } : _ref$color,
      renderLeft = _ref.renderLeft,
      renderRight = _ref.renderRight,
      onClick = _ref.onClick,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 3 : _ref$radius,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      square = _ref.square,
      title = _ref.title,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "color", "renderLeft", "renderRight", "onClick", "radius", "size", "square", "title"]);

  var _useBoxSize = useBoxSize(size),
      boxSize = _useBoxSize.boxSize,
      fontSize = _useBoxSize.fontSize,
      lineHeight = _useBoxSize.lineHeight,
      paddingHorizontal = _useBoxSize.paddingHorizontal,
      paddingHorizontalDense = _useBoxSize.paddingHorizontalDense,
      paddingVertical = _useBoxSize.paddingVertical;

  var textStyle = {
    as: 'span',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    color: 'inherit'
  };

  if (square || radius === 'circle') {
    restProps.width = boxSize;
    restProps.height = boxSize;
  }

  if (radius === 'circle') {
    textStyle.position = 'absolute';
    textStyle.top = '50%';
    textStyle.left = '50%';
    textStyle.transform = 'translate(-50%, -50%)';
  }

  var spacingLeft = renderLeft ? boxSize + 0.5 : radius === 'pill' ? paddingHorizontal : paddingHorizontalDense;
  var spacingRight = renderRight ? boxSize + 0.5 : radius === 'pill' ? paddingHorizontal : paddingHorizontalDense;
  return /*#__PURE__*/React.createElement(StackView, _extends({
    inline: true,
    axis: "horizontal",
    alignment: "center",
    distribution: "center",
    radius: radius,
    fontSize: fontSize,
    lineHeight: lineHeight,
    minHeight: boxSize,
    paddingLeft: spacingLeft,
    paddingRight: spacingRight,
    paddingVertical: paddingVertical,
    backgroundColor: color.background || color,
    color: color.foreground || getForegroundColor(color),
    fill: "currentColor",
    textAlign: "center",
    position: "relative",
    cursor: "default",
    outline: 0,
    focus: {
      backgroundColor: 'highlightSecondary'
    },
    onClick: stopPropagationClick(onClick)
  }, restProps), renderLeft && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: boxSize,
    height: boxSize,
    position: "absolute",
    top: 0,
    left: 0
  }, typeof renderLeft === 'string' ? renderLeft : /*#__PURE__*/cloneElement(renderLeft, {
    size: renderLeft.props && renderLeft.props.size || size
  })), typeof title === 'undefined' ? children : /*#__PURE__*/React.createElement(Text, textStyle, title), renderRight && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: boxSize,
    height: boxSize,
    position: "absolute",
    top: 0,
    right: 0
  }, typeof renderRight === 'string' ? renderRight : /*#__PURE__*/cloneElement(renderRight, {
    size: renderRight.props && renderRight.props.size || size
  })));
}

export default Badge;